'use es6';

import { FetchContactsInCrmRequestTypes } from 'pricing-pages-unified-ui/actions/NumContactsInCrmActions';

const NumContactsInCrm = (state = 0, {
  type,
  payload
}) => {
  switch (type) {
    case FetchContactsInCrmRequestTypes.RECEIVE:
      {
        const {
          data
        } = payload;
        return data;
      }

    default:
      return state;
  }
};

export default NumContactsInCrm;